export const hasIntersection = (a, b) =>
  a.filter(aItem => b.includes(aItem)).length;
